import React, { useState } from "react";
import _ from "lodash";
import { Elements } from "@stripe/react-stripe-js";
import { useRouter } from "next/router";

import { Product } from "../../types/Product";
import World from "../../world";
import NewGalleryForm from "../NewGalleryForm";
import Stripe from "../Stripe";

type Props = {
    world: World;
    stripePubKey: string;
    gallery_name?: string; // convert trial gallery
}

enum Step {
    Details = 1,
    Payment = 2,
}

export interface State {
    display_name: string;
    date: string;
    step: Step;
}

const NewGalleryController = (props: Props) => {
    const router = useRouter();
    const [displayName, setDisplayName] = useState("");
    const [date, setDate] = useState("");
    const [step, setStep] = useState(1);
    const [err, setErr] = useState("");

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "display_name":
            setDisplayName(e.currentTarget.value);
            break;
        case "date":
            setDate(_.trim(e.currentTarget.value));
            break;
        }
    }

    const handleCancel = (): void => {
        router.push("/dashboard/[[...all]]", "/dashboard");
    }

    const handleSubmitStep1 = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (displayName == "") {
            setErr("Please name your gallery")
            return;
        }

        const dateRX = /^\d\d\d\d-\d\d-\d\d$/;
        if (!dateRX.test(date)) {
            setErr("Please enter a valid date like 2023-09-21");
            return;
        }

        setStep(2);

        // AdWords
        (window as any).gtag('event', 'conversion', {'send_to': 'AW-10896578733/VKd9CO6-ksUDEK2x8sso'});
        // Facebook pixel
        (window as any).fbq("track", "InitiateCheckout");
    }

    const handlePaid = async (paymentIntentID: string, dollarsPaid: number): Promise<string> => {
        const [gallery, err] = await props.world.newGallery(
            props.world.host.name,
            {
                display_name: displayName,
                date: date,
            },
            paymentIntentID,
        );
        if (err) {
            return err.message;
        }
        // AdWords
        (window as any).gtag('event', 'conversion', {
            'send_to': 'AW-10896578733/j3X6COu-ksUDEK2x8sso',
            'value': dollarsPaid,
            'currency': 'USD',
            'transaction_id': `${gallery.id()}`,
        });
        // Facebook pixel
        (window as any).fbq("track", "Purchase", {
            currency: "USD",
            value: dollarsPaid,
        }, {
            eventID: `${gallery.id()}`,
        });

        // Share a sale tracking pixel
        const img = window.document.createElement("img");
        img.width = 1;
        img.height = 1;
        img.src = `https://www.shareasale.com/sale.cfm?tracking=${gallery.access_token}&amount=${dollarsPaid}&merchantID=110222&transtype=sale`;
        window.document.body.appendChild(img);
        const script = window.document.createElement("script");
        script.defer = true;
        script.type = "text/javascript";
        script.src = "https://www.dwin1.com/19038.js";
        window.document.body.appendChild(script);

        router.push("/dashboard/[[...all]]", "/dashboard");

        return "";
    }

    if (step === 1) {
        return <NewGalleryForm error={err} onChange={handleChange} onSubmit={handleSubmitStep1} onCancel={handleCancel} is_trial={false} />
    }

    return <Stripe world={props.world} onSuccess={handlePaid} stripe_pub_key={props.stripePubKey}/>
}

export default NewGalleryController;
